module.exports = __webpack_public_path__ + "static/media/ProjectStep1.76374c9a.png";